import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';

import IframeLayout from '../components/iframe-layout/iframe-layout';
import IframePromo from '../components/iframe-promo/iframe-promo';

const SSGovernmentPromo = ({ data }) => {
  // Pull out the relevant content from the data.
  // Make sure at least one result is returned before rendering the layout.
  const content = data.allTaxonomyTermPromotion.edges[0].node.relationships
    ? data.allTaxonomyTermPromotion.edges[0].node.relationships
      .field_promoted_content[0]
    : null;

  return (
    <React.Fragment>
      {content && (
        <IframeLayout>
          <IframePromo content={content} />
        </IframeLayout>
      )}
    </React.Fragment>
  );
};

SSGovernmentPromo.propTypes = {
  data: PropTypes.object
};

export default SSGovernmentPromo;

export const query = graphql`
  query SSGovernment {
    allTaxonomyTermPromotion(filter: { drupal_id: { eq: "411ae06d-89a3-4e10-90fd-c86eddf59713" } }) {
      edges {
        node {
          name
          relationships {
            field_promoted_content {
              ...IframeEvent
              ...IframeNews
              ...IframePlace
            }
          }
        }
      }
    }
  }
`;
